import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setActiveLoginModal } from '../app/features/userSlice';

export const useRedirect = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	// Slice
	const { user_email } = useSelector((state) => state.user);
	const { requestLogin } = useSelector((state) => state.institution);

	const redirect = (route) => {
		if (requestLogin) {
			if (user_email.length > 0) {
				navigate(`/${route}`);
			} else {
				dispatch(setActiveLoginModal(true));
			}
		} else {
			navigate(`/${route}`);
		}
	};
	return { redirect };
};
